export const ADD_MESSAGE = 'ADD_MESSAGE'
export const SET_AGENT = 'SET_AGENT'
export const SET_AGENT_CONNECTION = 'SET_AGENT_CONNECTION'
export const LOAD_AGENT_CONVERSATIONS = 'LOAD_AGENT_CONVERSATIONS'
export const SET_CONVERSATIONS = 'SET_CONVERSATIONS'
export const SET_LOGING_IN_PROGRESS = 'SET_LOGING_IN_PROGRESS'
export const SET_MESSAGES = 'SET_MESSAGES'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_SELECTED_CONVERSATION = 'SET_SELECTED_CONVERSATION'
